export const syncKeyboardValue = (keyboardRef, value) => {
  const keyboard = keyboardRef?.current;
  if (!keyboard) {
    return;
  }
  const next = String(value ?? '');
  if (typeof keyboard.setInput === 'function') {
    keyboard.setInput(next);
  }
  if (typeof keyboard.setCaretPosition === 'function') {
    keyboard.setCaretPosition(next.length);
  }
};

export const applyKeyboardButton = (button, currentValue = '', options = {}) => {
  const { maxLength, sanitize } = options;
  let next = String(currentValue ?? '');

  if (button === '{bksp}') {
    next = next.slice(0, -1);
  } else if (button && !String(button).startsWith('{')) {
    next = `${next}${button}`;
  }

  if (typeof sanitize === 'function') {
    next = sanitize(next);
  }
  if (typeof maxLength === 'number') {
    next = next.slice(0, maxLength);
  }
  return next;
};
